/*
 *   Copyright (c) 2020
 *   All rights reserved.
 */

import { createAction } from 'redux-actions';
import * as types from '@src/store/types';

export const getOtherUserProfileCall = createAction(
  types.GET_OTHER_USER_PROFILE_CALL
);
export const getOtherUserProfileDone = createAction(
  types.GET_OTHER_USER_PROFILE_DONE
);
export const getOtherUserProfileFail = createAction(
  types.GET_OTHER_USER_PROFILE_FAIL
);
